import { db } from "../../config/main_config";
// import { getAssignees } from "../getAssignees.module";
import { waitForWindowProperty } from "./routerAdditives.util";
import { getUserById } from "./getUsersList.util";

/**
 * Interface representing user data structure.
 */
interface UserData {
    firstName: string;
    lastName: string;
    [key: string]: any; // For any additional properties
}

/**
 * Interface representing an assignee.
 */
interface Assignee {
    userID: string;
    firstName: string;
    lastName: string;
    [key: string]: any; // For any additional properties
}

/**
 * Interface representing MSP data structure.
 */
interface MSPData {
    mspID: string;
    companyName: string;
    mspUsers: string[];
    mspUser: boolean;
}

// Extend the Window interface to include assignees
declare global {
    interface Window {
        assignees?: any[];
    }
}

/**
 * Checks the database for a user with the given UID and returns their full name.
 * This is kept for backward compatibility but uses the new getUserById function.
 * @param uid - The UID of the user to look up.
 * @returns A promise that resolves to the user's full name or 'User not found' if not found.
 */
const checkDatabase = async (uid: string): Promise<string> => {
    try {
        const user = await getUserById(uid);
        if (user) {
            if (user.firstName && user.lastName) {
                return `${user.firstName} ${user.lastName}`;
            } else {
                return 'User not found';
            }
        } else {
            return 'User not found';
        }
    } catch (error: any) {
        console.error(`[Utilities] (checkDatabase) Error checking database: ${error.message}`, { uid });
        return uid.toLowerCase() === 'unassigned' ? 'Unassigned' : 'User not found';
    }
};

/**
 * Searches for a user's name based on their UID, first checking in window.assignees and then in the database if needed.
 * @param uid - The UID of the user to look up.
 * @returns A promise that resolves to the user's full name, company name (for MSP), or 'Deleted or Unknown User' if not found.
 */
export const nameFromUID = async (uid: string, secondAttempt: boolean = false): Promise<string> => {
    if (!uid) return "Unassigned";

    try {
        // First try to get the user using the new method
        const user = await getUserById(uid);
        if (user && user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }

        // Fallback to old method using window.assignees for backward compatibility
        // await waitForWindowProperty("assignees", async () => { }, async () => { await getAssignees(); });
        // if (window.assignees && window.assignees.length > 0) {
        //     for (let assignee of window.assignees) {
        //         // Check if assignee is an MSP
        //         if (assignee.mspUser && assignee.mspID && assignee.companyName) {
        //             // Check if uid matches MSP ID
        //             if (assignee.mspID === uid) {
        //                 return assignee.companyName;
        //             }

        //             // Check if uid is in mspUsers array
        //             if (assignee.mspUsers && Array.isArray(assignee.mspUsers) &&
        //                 assignee.mspUsers.includes(uid)) {
        //                 return assignee.companyName;
        //             }
        //         }

        //         // Standard individual user check
        //         if (assignee.userID === uid) {
        //             return `${assignee.firstName} ${assignee.lastName}`;
        //         }
        //     }
        // }

        return 'Deleted or Unknown User';
    } catch (error) {
        console.error(`[Utilities] (nameFromUID) Error finding user by UID: ${error}`);
        return uid.toLowerCase() === 'unassigned' ? 'Unassigned' : 'User not found';
    }
}
